import React, { useContext } from "react"
import UsuarioContext from "../Context/Usuario"

const EditarBenchmark = (props) => {
  const { usuario } = useContext(UsuarioContext)
  const field = usuario.atributos["programaid_anterior"]

  if (!props.cohorte) {
    return <Form.Control type="text" defaultValue="" />
  }

  return (
    <Form.Group>
      <Form.Label>{field.title}</Form.Label>
      <Form.Control type="select">
        {Object.values(usuario.cohortes).map((cohorte) => {
          return <option value={cohorte.id}>{cohorte.nombre}</option>
        })}
      </Form.Control>
    </Form.Group>
  )
}

export default EditarBenchmark
